import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, json } from "../../../api";

export function useCacheRetention(workspaceId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (retentionDays: number | null) =>
      api<{ retentionDays: number | null }>(
        `/workspaces/${workspaceId}/cache-retention`,
        json({ retentionDays }),
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["workspace", workspaceId, "cache-stats"],
      });
    },
  });
}
